import React from 'react';
import { isNaN } from 'lodash';
import PropTypes from 'prop-types';
import { InputNumber } from '@sm360/widget-commons-forms';
import { PurchaseMethodsV25, PaymentOptionsMetadata, Quote } from '@sm360/widget-commons-vehicle';
import { LocaleService } from '@sm360/widget-commons-core-services';

import CustomizePaymentFrequency from 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CustomizePayment/CustomizePaymentFrequency.jsx';

import 'rc-slider/assets/index.css';

class CustomizePaymentTarget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            targetValue: props?.purchaseMethods?.getCalculatorOptions()?.selectedPayment?.payment || 0,
        };

        this.setTargetPayment = this.setTargetPayment.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            targetValue: newProps?.purchaseMethods?.getCalculatorOptions()?.selectedPayment?.payment || 0,
        });
    }

    setTargetPayment(value) {
        let newValue = parseFloat(value);
        if (isNaN(newValue) || newValue < 0) {
            newValue = 0;
        }
        this.setState({ targetValue: newValue });
        this.props.onTargetPaymentSlide(newValue, this.props.config);
    }

    render() {
        const validPaymentRange =
            this.props?.purchaseMethods?.getCalculatorOptions()?.selectedPayment?.validPaymentRange || null;
        const minRange = validPaymentRange?.[0] || 0;
        const maxRange = validPaymentRange?.[1] || 100;

        let step = 25;
        if (validPaymentRange && maxRange < 75) {
            step = 5;
        } else if (validPaymentRange && maxRange < 150) {
            step = 10;
        } else if (validPaymentRange && maxRange < 200) {
            step = 20;
        }
        return (
            <div className="customize-payment-slider-price-wrapper">
                <div className="customize-payment--pricewrapper is-light clearfix">
                    <div className="customize-payment-title">
                        {LocaleService.t('PAYMENT_CALCULATOR_V25.IWANTTOPAY')} :
                    </div>
                    <div className="customize-payment-details">
                        <InputNumber
                            min={minRange}
                            max={parseFloat(Math.round(maxRange * 100) / 100)}
                            onChange={this.setTargetPayment}
                            step={step}
                            value={this.state.targetValue.toFixed(2)}
                            decimalCount={2}
                            showLabel={false}
                        />
                        <CustomizePaymentFrequency
                            purchaseMethods={this.props.purchaseMethods}
                            onPaymentFrequencyClick={this.props.onPaymentFrequencyClick}
                            paymentOptionsMetadata={this.props.paymentOptionsMetadata}
                            quote={this.props.quote}
                            config={this.props.config}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

CustomizePaymentTarget.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    onTargetPaymentSlide: PropTypes.func.isRequired,
    onPaymentFrequencyClick: PropTypes.func.isRequired,
    paymentOptionsMetadata: PropTypes.arrayOf(PropTypes.instanceOf(PaymentOptionsMetadata.PaymentOptionsMetadataModel))
        .isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
};

CustomizePaymentTarget.displayName = 'CustomizePaymentTarget';

export default CustomizePaymentTarget;
